export default "/images/ad-studio-dark_logo.png?c63b81a1f8965dea3466b8e79e8541d9";